import React, {useState} from "react";
import { useHistory } from "react-router-dom";
import SweetAlert from "react-bootstrap-sweetalert";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons

// Core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Operation from "components/soubrier/Operations/Operation.js";

import OperationsService from "services/operations.service";

import styles from "assets/jss/soubrier/components/operationsListeStyle.js";

const useStyles = makeStyles(styles);

export default function AddOperation(props) {
  const classes = useStyles();
  const history = useHistory();
  const [alert, setAlert] = useState(null);

  const devis_id = props.location.devis_id;
  const operation_type = props.location.operation_type;

  const onSubmit = (article) => {
    OperationsService.add({...article})
    .then(function (response) {
      successAlert(response.data)
    })
    .catch(function (error) {
      console.log(error);
    });
  }
  const warningWithConfirmMessage = () => {
    setAlert(
      <SweetAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title="êtes vous sur de vouloir quitter cette page?"
        onConfirm={() =>  history.goBack()}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + " " + classes.success}
        cancelBtnCssClass={classes.button + " " + classes.danger}
        confirmBtnText="Oui"
        cancelBtnText="Annuler"
        showCancel
      >
        Toutes les modifications seront perdues!
      </SweetAlert>
    );
  };

  const successAlert = (data) => {
    setAlert(
      <SweetAlert
        success
        style={{ display: "block", marginTop: "-100px" }}
        title="Opération sauvegardé!"
        onConfirm={() => history.push(`/admin/operations/edit/${data.operation_id}`)}
        onCancel={() => history.go(0)}
        confirmBtnCssClass={classes.button + " " + classes.success}
        cancelBtnCssClass={classes.button + " " + classes.success}
        confirmBtnText="Voir l'opération"
        cancelBtnText="Ajouter une nouvelle opération"
        showCancel
      >
      </SweetAlert>
    );
  };

  const hideAlert = () => setAlert(null);
  
  const onCancel = () => {
    warningWithConfirmMessage();
  }

  return (
    <GridContainer>
      {alert}
      <GridItem xs={12} sm={12} md={12}>
        <Operation onSubmit={onSubmit} onCancel={onCancel} devis_id={devis_id} operation_type={operation_type}/>  
        {/* <Operation onSubmit={onSubmit} onCancel={onCancel} />   */}
      </GridItem>
    </GridContainer>
  );
}
